'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavDrawerBody", {
    enumerable: true,
    get: function() {
        return NavDrawerBody;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactdrawer = require("@fluentui/react-drawer");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useNavDrawerBody = require("./useNavDrawerBody");
const _useNavDrawerBodyStylesstyles = require("./useNavDrawerBodyStyles.styles");
const NavDrawerBody = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNavDrawerBody.useNavDrawerBody_unstable)(props, ref);
    (0, _useNavDrawerBodyStylesstyles.useNavDrawerBodyStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useNavDrawerBodyStyles_unstable')(state);
    return (0, _reactdrawer.renderDrawerBody_unstable)(state);
});
NavDrawerBody.displayName = 'NavDrawerBody';
